export default {
    section: 'Post-Transition Consulting',
    name: 'offer-letter-post-transition',
    items: [
        {
            type: 'radio-list',
            text: 'Client Service Provider',
            name: 'offer-letter-post-transition-client-service-provider',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'textarea',
                    text: 'Description of Role',
                    name: 'offer-letter-post-transition-client-service-provider-role',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-client-service-provider',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Compensation Method',
                    name: 'offer-letter-post-transition-client-service-provider-compensation',
                    props: {
                        row: true,
                        items: [
                            {
                                text: '1099 Contractor',
                                value: '1099'
                            },
                            {
                                text: 'W-2 Salary',
                                value: 'w2'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-client-service-provider',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Compensation',
                    name: 'offer-letter-post-transition-client-service-provider-w2-pay',
                    width: 3,
                    props: {
                        label: 'Compensation',
                        format: 'dollars'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-client-service-provider',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Compensation Timeframe',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-client-service-provider-contractor-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-client-service-provider-contractor-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-client-service-provider',
                                value: 'yes'
                            },
                            {
                                name: 'offer-letter-post-transition-client-service-provider-compensation',
                                value: '1099'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Payment of New Revenue Generated',
                    name: 'offer-letter-post-transition-client-service-provider-revenue-percent',
                    width: 3,
                    props: {
                        label: 'Payment',
                        format: 'percent'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-client-service-provider',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Payment of New Revenue Generated Timeframe',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-client-service-provider-revenue-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-client-service-provider-revenue-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-client-service-provider',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Length of Agreement',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-client-service-provider-agreement-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-client-service-provider-agreement-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-client-service-provider',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Renewable',
                    name: 'offer-letter-post-transition-client-service-provider-renewable',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-client-service-provider',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Notes',
                    name: 'offer-letter-post-transition-client-service-provider-notes',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-client-service-provider',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Business Development or Rainmaking',
            name: 'offer-letter-post-transition-business-development',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'radio-list',
                    text: 'Compensation Method',
                    name: 'offer-letter-post-transition-business-development-compensation',
                    props: {
                        row: true,
                        items: [
                            {
                                text: '1099 Contractor',
                                value: '1099'
                            },
                            {
                                text: 'W-2 Salary',
                                value: 'w2'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-business-development',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Compensation',
                    name: 'offer-letter-post-transition-business-development-w2-pay',
                    width: 3,
                    props: {
                        label: 'Compensation',
                        format: 'dollars'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-business-development',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Compensation Timeframe',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-business-development-contractor-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-business-development-contractor-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-business-development',
                                value: 'yes'
                            },
                            {
                                name: 'offer-letter-post-transition-business-development-compensation',
                                value: '1099'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Payment of New Revenue Generated',
                    name: 'offer-letter-post-transition-business-development-revenue-percent',
                    width: 3,
                    props: {
                        label: 'Payment',
                        format: 'percent'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-business-development',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Payment of New Revenue Generated Timeframe',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-business-development-revenue-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-business-development-revenue-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-business-development',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Example',
                    name: 'offer-letter-post-transition-business-development-revenue-example',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-business-development',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Length of Agreement',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-business-development-agreement-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-business-development-agreement-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-business-development',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Renewable',
                    name: 'offer-letter-post-transition-business-development-renewable',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-business-development',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Notes',
                    name: 'offer-letter-post-transition-business-development-notes',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-business-development',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Mentorship or Coaching',
            name: 'offer-letter-post-transition-mentorship',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'radio-list',
                    text: 'Who',
                    name: 'offer-letter-post-transition-mentorship-who',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Junior Advisors',
                                value: 'junior-advisors'
                            },
                            {
                                text: 'Business Owners',
                                value: 'business-owners'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-mentorship',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Fee Per Meeting',
                    name: 'offer-letter-post-transition-mentorship-fee-percent',
                    width: 3,
                    props: {
                        label: 'Fee',
                        format: 'percent'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-mentorship',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Fee Per Meeting Timeframe',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-mentorship-fee-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-mentorship-fee-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-mentorship',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Length of Agreement',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-mentorship-agreement-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-mentorship-agreement-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-mentorship',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Renewable',
                    name: 'offer-letter-post-transition-mentorship-renewable',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-mentorship',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Notes',
                    name: 'offer-letter-post-transition-mentorship-notes',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-mentorship',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'radio-list',
            text: 'Portfolio Investment Management & Financial Plans',
            name: 'offer-letter-post-transition-portfolio-investment',
            props: {
                row: true,
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            },
            subItems: [
                {
                    type: 'textarea',
                    text: 'Description of Role',
                    name: 'offer-letter-post-transition-portfolio-investment-role',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-portfolio-investment',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Compensation Method',
                    name: 'offer-letter-post-transition-portfolio-investment-compensation',
                    props: {
                        row: true,
                        items: [
                            {
                                text: '1099 Contractor',
                                value: '1099'
                            },
                            {
                                text: 'W-2 Salary',
                                value: 'w2'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-portfolio-investment',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'text-field',
                    text: 'Compensation',
                    name: 'offer-letter-post-transition-portfolio-investment-w2-pay',
                    width: 3,
                    props: {
                        label: 'Compensation',
                        format: 'dollars'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-portfolio-investment',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Compensation Timeframe',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-portfolio-investment-contractor-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-portfolio-investment-contractor-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-portfolio-investment',
                                value: 'yes'
                            },
                            {
                                name: 'offer-letter-post-transition-portfolio-investment-compensation',
                                value: '1099'
                            }
                        ]
                    }
                },
                {
                    type: 'inline',
                    text: 'Length of Agreement',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-post-transition-portfolio-investment-agreement-time-duration',
                            width: 3,
                            props: {
                                label: 'Duration',
                                format: 'number'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-post-transition-portfolio-investment-agreement-time-units',
                            width: 3,
                            props: {
                                items: [
                                    {
                                        text: 'Months',
                                        value: 'months'
                                    },
                                    {
                                        text: 'Years',
                                        value: 'years'
                                    }
                                ]
                            }
                        }
                    ],
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-portfolio-investment',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'radio-list',
                    text: 'Renewable',
                    name: 'offer-letter-post-transition-portfolio-investment-renewable',
                    props: {
                        row: true,
                        items: [
                            {
                                text: 'Yes',
                                value: 'yes'
                            },
                            {
                                text: 'No',
                                value: 'no'
                            }
                        ]
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-portfolio-investment',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    type: 'textarea',
                    text: 'Notes',
                    name: 'offer-letter-post-transition-portfolio-investment-notes',
                    props: {},
                    dependencies: {
                        items: [
                            {
                                name: 'offer-letter-post-transition-portfolio-investment',
                                value: 'yes'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'textarea',
            text: 'Notes',
            name: 'offer-letter-post-transition-notes',
            props: {}
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/post-transition.js